/* eslint-disable react-hooks/exhaustive-deps */
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import CardFormularioStatus from 'components/forms/CardFormularioStatus';
import { IUser } from 'modules/auth/interfaces/storage.interface';
import { useEffect, useState } from 'react';
import { useFormulariosStore } from 'stores/forms/formularios.store';

interface PacoteMunicipalManagerProps {
  user: IUser;
}
const PacoteMunicipalManager: React.FC<PacoteMunicipalManagerProps> = ({
  user,
}) => {
  const { formularios, getFormulariosByInstitutionUUID, enviarFormularios } = useFormulariosStore();
  const [openDialogResponse, setOpenDialogResponse] = useState(false);
  const [envioSucesso, setEnvioSucesso] = useState(false);

  useEffect(() => {
    getFormulariosByInstitutionUUID(user.institution.uuid);
  }, []);

  const handleEnviarFormularios = async () => {
    const response = await enviarFormularios(user.institution.uuid);
    setEnvioSucesso(!!response);
    setOpenDialogResponse(true);
    getFormulariosByInstitutionUUID(user.institution.uuid);
  }

  const handleFecharDialog = () => {
    setOpenDialogResponse(false);
  }

  const handleTentarNovamente = () => {
    setOpenDialogResponse(false);
  }

  // verificar se todos estao com o status 3
  const todosStatus3 = formularios.every(
    (formulario) => formulario.status === 3,
  );

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={2}
      maxWidth={'1400px'}
      padding={6}
      paddingTop={2}
    >
      <Alert
        severity='info'
        sx={{ marginY: '2rem', backgroundColor: '#EAEFF9' }}
      >
        <Typography
          variant='body2'
          fontSize='16px'
          textAlign='left'
          lineHeight={1.5}
        >
          {`Para enviar o pacote de formulários ao Gerente Estadual, certifique-se de que todos os formulários estejam com o status 'Concluido'`}
        </Typography>
      </Alert>

      <Box display={'grid'} gridTemplateColumns={'repeat(2, 1fr)'} gap={2}>
        {formularios.map((formulario) => (
          <CardFormularioStatus key={formulario.uuid} {...formulario} />
        ))}
      </Box>

      <Box display={'flex'} justifyContent={'flex-end'} mt={2}>
        <Button variant='contained' color='primary'
          disabled={!todosStatus3}
          onClick={handleEnviarFormularios}>
          Enviar Formulário
        </Button>
      </Box>

      <Dialog
        open={openDialogResponse}
        onClose={handleFecharDialog}
      >
        <DialogTitle>
          {envioSucesso ? 'Sucesso!' : 'Erro no Envio'}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {envioSucesso
              ? 'Formulários enviados com sucesso para o Gerente Estadual.'
              : 'Ocorreu um erro ao enviar os formulários. Tente novamente.'}
          </Typography>
        </DialogContent>
        <DialogActions>
          {envioSucesso ? (
            <Button variant='contained' color='primary' onClick={handleFecharDialog}>
              OK
            </Button>
          ) : (
            <>
              <Button variant='outlined' onClick={handleFecharDialog}>
                Cancelar
              </Button>
              <Button variant='contained' color='primary' onClick={handleTentarNovamente}>
                Tentar Novamente
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PacoteMunicipalManager;
